export function mounted() {
  this.$store.dispatch('unit/getStatesList', {
    useAbbreviated: true
  })
}
